import { Injectable } from '@angular/core';
import { AngularFireDatabase } from "@angular/fire/database";
import { LogService } from "./log-servicios";

//import { auth } from 'firebase/app';
import { Observable } from 'rxjs';		//, ReplaySubject 
import { map } from 'rxjs/operators';		//, tap, catchError, first
import { EmpIdPref, EmpAut, PedirAccesoEmp } from '../interfaces/empresa-interfaces';

@Injectable({
  providedIn: 'root'
})
export class FireEmpresaService {
  constructor(
    private db: AngularFireDatabase,
    private logService: LogService
  ) { }
  
  getFireEmpIdPref$(pref: string): Observable<EmpIdPref> {
    return this.db.object<EmpIdPref>('empIdPref/easymed/' + pref)
      .valueChanges()
      .pipe(
        map(feip => {
          this.logService.consoleLog('2', 'CS FE feip service get eid: ' + feip.eid);
          return feip;
        })
      );
  }

  e1: EmpAut = new EmpAut;

  getFireEmpAut$(eid: string): Observable<EmpAut> {
    return this.db.object<EmpAut>('empAut/easymed/' + eid)
      .valueChanges()
      .pipe(
        map(fe => {
          this.logService.consoleLog('2', 'CS FE fe service get eid: ' + fe.eid);
          this.e1 = fe;
          return this.e1;
        })
      );
  }

  getFireEmpAutsAdmin$(): Observable<EmpAut[]> {
    return this.db.list<EmpAut>('empAut/easymed', ref =>
      ref.orderByChild('fechaHora')	//
    )
      .valueChanges()
      .pipe(
        map(feas => {
          return feas;
        })
      );
  }
  
  getFirePedirAccesoEmpsAdmin$(): Observable<PedirAccesoEmp[]> {
    return this.db.list<PedirAccesoEmp>('pedirAccesoEmp/easymed', ref =>
      ref.orderByChild('fechaHora')	//
    )
      .valueChanges()
      .pipe(
        map(fpaes => {
          return fpaes;
        })
      );
  }
  
  //set puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  createFireEmpAut$(objEmpAut: EmpAut): Promise<void> {
    //const objEmpAut = {autorizado: autorizado, email:mail}
    this.logService.consoleLog('2','CS FireEmp ' + objEmpAut.nombre);
    return this.db.list('empAut/easymed/').set(objEmpAut.eid, objEmpAut);
  }

  //set puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  createFirePedirAccesoEmp$(objPedirEmp: PedirAccesoEmp): Promise<void> {
    //const objEmpAut = {autorizado: autorizado, email:mail}
    this.logService.consoleLog('2','CS FirePedirEmp ' + objPedirEmp.nombre);
    return this.db.list('pedirAccesoEmp/easymed/').set(objPedirEmp.paeid, objPedirEmp);
  }

}

